import { withTranslation } from "react-i18next";

import React from 'react';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { Footer, Header } from '../Common';
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import Affiliator from '../../Models/Affiliator';
class CreateLink extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('2'))
            this.props.history.push('/login/affiliator');
        };
        this.state = {
            _id: false,
            errors: []
        };
        console.log(this.props.location.state)
    };
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    handleSubmit(e) {
        if (window.confirm(this.props.t('0')+'?')) {
            e.preventDefault();
            let data = {
                line_link: this.props.location.state.line_link,
                web_link: this.props.location.state.web_link,
                aff_id: this.props.location.state.aff_id,
                pro_id: this.props.location.state.product_id
            }
            Affiliator.saveAffiliatedProducts(data).then(res => {
                console.log(res.data.status);
                // this.setState({})
                if (res.data.status === 200) {
                    alert(this.props.t('1'))
                    this.props.history.push('/affiliator-individual-products')
                } else {
                    this.setState({ errors: res.data.message })
                }
            })
        }
    }
    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    <AffiliatorSidebar />
                                </div>
                                <div className="col-md-8">

                                    <div className="big_font  ml-5 pb-2">
                                        {this.state.errors}
                                    </div>
                                    <div className="big_font  ml-4 pb-2">
                                        {this.props.t('5')}
                                    </div>
                                    <div className="mail_box" style={{ height: '100px' }}>
                                        <div className="col-md-12 tr_blank_medium mt-2 pt-2"></div>
                                        <div className="mail_box_input text-center" style={{ backgroundColor: 'white' }}>{this.props.location.state.line_link}</div>
                                    </div>
                                    <div className="big_font mt-4 ml-4 pb-2">
                                        Web{this.props.t('3')}
                                    </div>
                                    <div className="mail_box">
                                        <div className="col-md-12 tr_blank_medium mt-2 pt-2"></div>
                                        <div className="mail_box_input text-center" style={{ backgroundColor: 'white' }}>{this.props.location.state.web_link}</div>
                                    </div>
                                    <div className='text-center mt-5'>
                                        <button className="" style={{width: '150px',marginLeft: '45px',backgroundColor: "#7ea9e6",borderColor: "#6290d1",height:'40px',borderRadius:'5px',color:'#fff',boxShadow:"#ffffff4d 0px 1px 0px 0px inset"}} onClick={this.handleSubmit.bind(this)}>{this.props.t('4')}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export { CreateLink }


 CreateLink = withTranslation('src_Components_Affiliator_CreateLink')(CreateLink);
